// extracted by mini-css-extract-plugin
module.exports = {"root":"ProductionInfo_root__1o4up","label_container":"ProductionInfo_label_container__1YYqD"};